<template>
  <div :class="classes" :style="warpstyles">
    <Notice
      v-for="notice in notices"
      :key="notice.name"
      :name="notice.name"
      :type="notice.type"
      :content="notice.content"
      :duration="notice.duration"
      :closable="notice.closable"
      :onClose="notice.onClose"
    ></Notice>
    <!-- {{ notices }} -->
  </div>
</template>

<script>
import Notice from "./notice";
import { transferIndex, transferIncrease } from "@/utils/transfer-queue.js";

let seed = 0;
const now = Date.now();
function getUuid() {
  return "ivuNotification_" + now + "_" + seed++;
}

const prefixCls = "k-message";

export default {
  components: { Notice },
  data() {
    return {
      notices: [],
      tIndex: this.handleGetIndex(),
      styles: {
        top: "25px"
      }
    };
  },
  computed: {
    classes() {
      return [`${prefixCls}`];
    },
    warpstyles() {
      let styles = Object.assign({}, this.styles);
      styles["z-index"] = 1010 + this.tIndex;
      return styles;
    }
  },
  methods: {
    add(notice) {
      const name = notice.name || getUuid();

      let _notice = Object.assign({ name: name }, notice);
      this.notices.push(_notice);
    },
    close(name) {
      // console.log("close", name);
      const notices = this.notices;
      for (let i = 0; i < notices.length; i++) {
        if (notices[i].name === name) {
          this.notices.splice(i, 1);
          break;
        }
      }
    },
    closeAll() {
      this.notices = [];
    },
    handleGetIndex() {
      transferIncrease();
      return transferIndex;
    }
  }
};
</script>
